import { createApi } from '@reduxjs/toolkit/query/react';

import { URL } from 'api/constants';
import { addParamsToUrl } from 'utils/query';
import { CourseSubmission, PaginationResponse } from 'types';
import { providesList, invalidatesList } from 'utils/query-cache';

import { apiQuery } from '../../query';

import {
  ListResponse,
  CourseSubmissionsListRequest,
  UpdateCourseSubmissionCompletedRequest,
} from './types';

const tagType = 'COURSE_SUBMISSIONS';

export const courseSubmissionsApi = createApi({
  tagTypes: [tagType],
  baseQuery: apiQuery,
  reducerPath: 'courseSubmissionsApi',
  endpoints: (build) => ({
    updateCompleted: build.mutation<
      CourseSubmission,
      UpdateCourseSubmissionCompletedRequest
    >({
      invalidatesTags: invalidatesList(tagType),
      query: ({ id, isCompleted }) => ({
        method: 'patch',
        data: { isCompleted },
        url: URL.COURSE_SUBMISSION_COMPLETED.replace(':id', id),
      }),
    }),
    list: build.query<
      PaginationResponse<CourseSubmission>,
      CourseSubmissionsListRequest
    >({
      providesTags: providesList(tagType),
      transformResponse: (response: ListResponse) => response.data,
      query: (params) => ({
        method: 'get',
        url: addParamsToUrl(URL.COURSE_SUBMISSIONS, params),
      }),
    }),
  }),
});

export const { useListQuery, useUpdateCompletedMutation } =
  courseSubmissionsApi;

export type {
  CourseSubmissionsListRequest,
  UpdateCourseSubmissionCompletedRequest,
};
